// Live showroomstatus uit de global "Openingstijden" (business_hours).
// De data staat als JSON in de layout (#renoco-data); alle statusregels op de
// site (kopbalk, hero, footer, boekingspaneel) lezen uit deze ene store.

const WEEKDAGEN = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const DAGNAMEN = {
    sunday: 'zondag',
    monday: 'maandag',
    tuesday: 'dinsdag',
    wednesday: 'woensdag',
    thursday: 'donderdag',
    friday: 'vrijdag',
    saturday: 'zaterdag',
};

function nuInAmsterdam() {
    const delen = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Amsterdam',
        weekday: 'long',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(new Date());

    const deel = (type) => delen.find((d) => d.type === type)?.value ?? '';

    return {
        weekdag: deel('weekday').toLowerCase(),
        minuten: parseInt(deel('hour'), 10) * 60 + parseInt(deel('minute'), 10),
    };
}

function naarMinuten(tijd) {
    const [uur, minuut] = String(tijd || '0:0').split(':').map(Number);
    return uur * 60 + (minuut || 0);
}

export function leesRenocoData() {
    try {
        return JSON.parse(document.getElementById('renoco-data')?.textContent || '{}');
    } catch (e) {
        return {};
    }
}

export default function maakOpeningstijden(data) {
    const dagen = Array.isArray(data?.openingstijden) ? data.openingstijden : [];

    const zoekDag = (weekdag) => dagen.find((d) => (d.weekday?.value ?? d.weekday) === weekdag);

    return {
        klaar: false,
        open: false,
        tekst: '',
        kort: '',
        vandaag: null,

        init() {
            this.bereken();
            setInterval(() => this.bereken(), 60 * 1000);
        },

        bereken() {
            if (!dagen.length) {
                this.klaar = false;
                return;
            }

            const nu = nuInAmsterdam();
            const vandaag = zoekDag(nu.weekdag);
            this.vandaag = vandaag ?? null;

            if (vandaag?.open && nu.minuten >= naarMinuten(vandaag.start_time) && nu.minuten < naarMinuten(vandaag.end_time)) {
                this.open = true;
                this.tekst = `Vandaag open tot ${vandaag.end_time}`;
                this.kort = `Open tot ${vandaag.end_time}`;
                this.klaar = true;
                return;
            }

            this.open = false;

            if (vandaag?.open && nu.minuten < naarMinuten(vandaag.start_time)) {
                this.tekst = `Vandaag open vanaf ${vandaag.start_time}`;
                this.kort = `Open vanaf ${vandaag.start_time}`;
                this.klaar = true;
                return;
            }

            const index = WEEKDAGEN.indexOf(nu.weekdag);
            for (let stap = 1; stap <= 7; stap++) {
                const weekdag = WEEKDAGEN[(index + stap) % 7];
                const dag = zoekDag(weekdag);
                if (dag?.open) {
                    const wanneer = stap === 1 ? 'Morgen' : DAGNAMEN[weekdag].charAt(0).toUpperCase() + DAGNAMEN[weekdag].slice(1);
                    this.tekst = `Nu gesloten · ${wanneer} open vanaf ${dag.start_time}`;
                    this.kort = `${wanneer} vanaf ${dag.start_time}`;
                    this.klaar = true;
                    return;
                }
            }

            this.tekst = 'Nu gesloten';
            this.kort = 'Gesloten';
            this.klaar = true;
        },
    };
}
